export default __webpack_public_path__ + "static/media/back.b1f4edb2.svg";